import script from "./owner-list.vue?vue&type=script&setup=true&lang=js"
export * from "./owner-list.vue?vue&type=script&setup=true&lang=js"

import "./owner-list.vue?vue&type=style&index=0&id=67c01de4&lang=scss&scoped=true"
import "./owner-list.vue?vue&type=style&index=1&id=67c01de4&lang=scss"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c01de4"]])

export default __exports__